import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CtaButtonSignalService } from '@app/finxone-web-frontend/app/lib/services/cta-button-signal-service/cta-button-signal.service';
import { BulkPaymentListState } from '@app/finxone-web-frontend/app/lib/state/bulk-payment.state';
import { FormActionState } from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { BulkPaymentMasterStatus, FormActionTypeEnum } from '@finxone-platform/form-action';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { bulkPaymentApproverRejectButton } from '../../bulk-payments/bulk-payments.utils';

export const bulkPaymentsCtaValidationMap: Map<
  ButtonActionType,
  (
    store: Store,
    ctaButtonSignalService: CtaButtonSignalService,
    attri?: UiZoneWidgetAttributeConfig,
    configService?: ConfigService,
  ) => Observable<any>
> = new Map<ButtonActionType, any>([
  [
    ButtonActionType.BULK_PAYMENT_ADD_BENEFICIARY,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri?: UiZoneWidgetAttributeConfig) => {
      const data = store.select(BulkPaymentListState.getBulkPaymentList);

      return data.subscribe({
        next: (res) => {
          const totalErrorPayments = res?.meta?.bulkPaymentsSummary?.totalErrors;
          const totalItems = res?.meta?.bulkPaymentsSummary?.totalPayments;
          const totalPendingPayments = res?.meta?.bulkPaymentsSummary?.totalPendingPayments;
          let isDisableButton = false;
          if (totalItems && !totalErrorPayments && !totalPendingPayments) {
            isDisableButton = true;
          }
          const key = attri?.['buttonActionType'] as string;
          ctaButtonSignalService.setSignal({
            [key]: isDisableButton,
          });
        },
      });
    },
  ],
  [
    ButtonActionType.BULK_PAYMENT_BENEFICIARY_VALIDATION,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri?: UiZoneWidgetAttributeConfig) => {
      const data = store.select(BulkPaymentListState.getBulkPaymentList);

      return data.subscribe({
        next: (res) => {
          const totalErrorPayments = res?.meta?.bulkPaymentsSummary?.totalErrors;
          const totalPendingBeneficiary = res?.meta?.bulkPaymentsSummary?.totalPendingBeneficiary;
          let isDisableButton = false;
          if (!totalErrorPayments && !totalPendingBeneficiary) {
            isDisableButton = true;
          }
          const key = attri?.['buttonActionType'] as string;
          ctaButtonSignalService.setSignal({
            [key]: isDisableButton,
          });
        },
      });
    },
  ],
  [
    ButtonActionType.BULK_PAYMENT_DOWNLOAD_UPLOAD_PROCESSING,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri?: UiZoneWidgetAttributeConfig) => {
      const data = store.select(FormActionState.getFormActionStateWithId(FormActionTypeEnum.BULK_PAYMENTS));
      return data.subscribe({
        next: (res) => {
          let isDisableButton = false;
          if (res?.formData?.myFiles?.length) {
            isDisableButton = true;
          }
          const key = attri?.['buttonActionType'] as string;
          ctaButtonSignalService.setSignal({
            [key]: isDisableButton,
          });
        },
      });
    },
  ],
  [
    ButtonActionType.BULK_PAYMENT_AUTHENTICATION_LINK,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri?: UiZoneWidgetAttributeConfig) => {
      const data = store.select(BulkPaymentListState.getBulkPaymentList);
      return data.subscribe({
        next: (res) => {
          const masterBulkPaymentStatus = res?.meta?.bulkPaymentsSummary?.masterStatus;
          let isDisableButton = false;
          if (
            [BulkPaymentMasterStatus.PENDING].includes(
              masterBulkPaymentStatus as unknown as BulkPaymentMasterStatus,
            )
          ) {
            isDisableButton = true;
          }
          const key = attri?.['buttonActionType'] as string;
          ctaButtonSignalService.setSignal({
            [key]: isDisableButton,
          });
        },
      });
    },
  ],
  [
    ButtonActionType.BULK_PAYMENT_CANCEL,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri?: UiZoneWidgetAttributeConfig) => {
      const bulkPaymentData = store.select(BulkPaymentListState.getBulkPaymentList);
      return bulkPaymentData.subscribe({
        next: (res) => {
          const masterBulkPaymentStatus = res?.meta?.bulkPaymentsSummary?.masterStatus;
          let isDisableButton = false;
          if (
            BulkPaymentMasterStatus.PENDING == (masterBulkPaymentStatus as unknown as BulkPaymentMasterStatus)
          ) {
            isDisableButton = true;
          }
          const key = attri?.['buttonActionType'] as string;
          ctaButtonSignalService.setSignal({
            [key]: isDisableButton,
          });
        },
      });
    },
  ],
  [
    ButtonActionType.BULK_PAYMENT_APPROVER,
    (
      store: Store,
      ctaButtonSignalService: CtaButtonSignalService,
      attri: UiZoneWidgetAttributeConfig,
      configService: ConfigService,
    ) => {
      bulkPaymentApproverRejectButton(store, ctaButtonSignalService, attri, configService);
    },
  ],
  [
    ButtonActionType.BULK_PAYMENT_REJECT,
    (
      store: Store,
      ctaButtonSignalService: CtaButtonSignalService,
      attri: UiZoneWidgetAttributeConfig,
      configService: ConfigService,
    ) => {
      bulkPaymentApproverRejectButton(store, ctaButtonSignalService, attri, configService);
    },
  ],
]);
